<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        :title="`Paciente ${data.pacienteNome}`"
    >
        <Form
            :id="data.pacienteId"
            @loaded="loaded"
            ref="Form"
        />
        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>


<script>
// Components.
import Form from '@/components/ambulatorio/historico-atendimento/Form'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        Form,
    },
    data: () => ({
        form: null,
        data: {},
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading',
        ]),
        open(data) {
            this.data = data
            this.$refs.RkmModal.show()
        },
        loaded(value) {
            this.form = value.form
        },
    },
    mixins: [error, repository]
}
</script>